import React, { useState, useEffect } from "react";
import { getCookieValue } from "../../utils/window.utils";
import { Link, RichText, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import "./index.scss";


const MarketBar = ({ bannerData, isRtl }) => {
  const [showBar, setShowBar] = useState(true);

  const submitLink = {
    value: {
      href: bannerData?.redirectUrl,
    },
  };

const cookieName = "usersMarket";

useEffect(() => {
  if (typeof window === "undefined" || !bannerData) return;

  const cookieValue = getCookieValue(cookieName); 
  const currentMarket = window.location.host + window.location.pathname;
  const targetMarket = bannerData?.redirectUrl;

  if (cookieValue === currentMarket) {
    setShowBar(false);
    return;
  }

  if (!cookieValue || cookieValue !== targetMarket) {
    setShowBar(true);
  } else {
    setShowBar(false);
  }
}, [bannerData]);

const handleConfirm = () => {
  if (typeof window !== "undefined") {
    document.cookie = `usersMarket=${bannerData.currentCountryCode}; path=/; max-age=31536000`;
    setShowBar(false);
  }
};

const handleSwitch = () => {
  if (bannerData?.suggestedCountryCode) {
    document.cookie = `usersMarket=${bannerData.suggestedCountryCode}; path=/; max-age=31536000`;
  }
};

  return (
    <>
      <section className={`language-module ${!showBar ? "disable" : "market-bar"} ${isRtl ? "language-module-rtl" : ""}`}>
        <div className="left-content">
          <div className="question">{bannerData?.labels?.message}</div>
          <div className="links">
            <a onClick={handleConfirm} className="Link">
              <span>
                {bannerData?.labels?.confirmBtn}
              </span>
            </a>

            <Link field={submitLink} className="Link" onClick={handleSwitch} >
              <span>
                {bannerData?.labels?.switchBtn}
              </span>
            </Link>
          </div>
        </div>
        <span className="close-icon" onClick={handleConfirm}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6693 10.6673L5.33594 5.33398" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.6693 5.33398L5.33594 10.6673" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </section>
    </>
  );
};

export default MarketBar;
